import React from "react";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Slide,
  Stack,
  Typography,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";

export interface BulkApplyFloatingActionProps {
  /** The aircraft that was selected */
  aircraftName: string;
  /** Number of visible unmatched rows that will be affected */
  matchCount: number;
  /** Callback when Apply button is clicked */
  onApply: () => void;
  /** Callback when dismissed */
  onDismiss: () => void;
}

export const BulkApplyFloatingAction: React.FC<
  BulkApplyFloatingActionProps
> = ({ aircraftName, matchCount, onApply, onDismiss }) => {
  return (
    <Slide direction="down" in={true}>
      <Paper
        elevation={3}
        sx={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          mt: 0.5,
          p: 1.5,
          zIndex: 1000,
          backgroundColor: "background.paper",
          borderLeft: 3,
          borderColor: "primary.main",
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <CheckCircleIcon fontSize="small" color="primary" />
          <Typography variant="body2" sx={{ flex: 1 }}>
            Apply <strong>{aircraftName}</strong> to all {matchCount} visible
            rows?
          </Typography>
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={onApply}
          >
            Apply
          </Button>
          <IconButton size="small" onClick={onDismiss}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Stack>
      </Paper>
    </Slide>
  );
};
